export const services = {
  title: "Additional Services",
  subtitle: "Complementary services to facilitate your family's school life",
  transport: {
    title: "Taxi from Vigo",
    description: "Taxi from Vigo. Minimum 4 places. This is the only service requiring a booking commitment for the whole term; the price shown is monthly.",
    roundTrip: "Round trip",
    roundTripPrice: "225€/month"
  },
  earlyBirds: {
    title: "Early Birds",
    schedule: "Daily service from 8:15h",
    monthly: "Monthly",
    monthlyPrice: "75€",
    daily: "Single days",
    dailyPrice: "7€",
    note: "* Price per family - Monday to Friday included"
  },
  lunch: {
    title: "Lunch Service",
    description: "Lunch and morning snack following a balanced diet with organic and local products",
    monthly: "5 days/week",
    monthlyPrice: "195€",
    threeDays: "3 days/week",
    twoDays: "2 days/week",
    perMonth: "/month",
    note: "Lunch plans are booked and paid monthly. Choose 5, 3 or 2 fixed days a week. After-lunch club included until 17:00 (16:00 on Fridays). Single days require 48 hours’ notice.",
    daily: "Single days",
    dailyPrice: "15€",
    takeaway: {
      title: "Takeaway option",
      description: "For the same price, you can also order food to pick up anytime between 2:00 PM and 5:00 PM. Container provided by Gándara."
    }
  },
  ludoteca: {
    title: "Tardes Gándara",
    schedule: "Schedule: 2:00 PM to 5:00 PM",
    description: "Lunch and ludoteca until 5:00 PM (Fridays, 4:00 PM), with 5, 3 or 2 day-a-week plans",
    freeWith: "See the 2026-27 after-school activities: timetable, activities and prices",
    options: [
      { label: "Lunch", price: "14:00 - 15:00" },
      { label: "Ludoteca", price: "15:00 - 17:00 (Fridays, 16:00)" }
    ],
    note: "* Information and bookings via WhatsApp: 616 975 363"
  },
  contact: {
    title: "Interested in any service?",
    description: "Contact us to learn more details and availability",
    button: "Book a visit"
  }
};
